export default __webpack_public_path__ + "static/media/qr-code.bbe91c38.svg";